import { useAccountCompanyId } from 'application/hooks';
import { refreshAccountData } from 'application/store';
import { useAppDispatch } from 'application/providers/StoreProvider';

import useRemoveCard from '@entities/paymentMethod/api/useRemoveCard';
import { useBillingCompanyBillingInfoQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

import { UseCardRemoveModalViewModel } from './types';

interface Props {
  showInfoNotification: () => void;
  showErrorNotification: () => void;
  close: () => void;
  afterClose?: () => void;
}

const useCardRemoveModalViewModel = ({
  showInfoNotification,
  showErrorNotification,
  close,
  afterClose,
}: Props): UseCardRemoveModalViewModel => {
  const companyId = useAccountCompanyId();
  const dispatch = useAppDispatch();

  const { request: removeCard, result: removeCardResult } = useRemoveCard();
  const { refetch } = useBillingCompanyBillingInfoQuery({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
    variables: { companyId },
  });

  const removeCardSubmit = async () => {
    try {
      const isOk = await removeCard(companyId);

      if (isOk) {
        showInfoNotification();
        await Promise.all([refetch(), dispatch(refreshAccountData(companyId))]);
        close();
        afterClose?.();
      }
    } catch (e) {
      showErrorNotification();
    }
  };

  return {
    removeCardSubmit,
    removeCardLoading: removeCardResult.loading,
  };
};

export default useCardRemoveModalViewModel;
